import * as React from "react";
import { BbntWishlistItemInput } from "../../../Common";

interface PdpAddToWishlistConsumerInterface {
  readWishlistItemsToAddFromTheCurrentStateOfTheDocument: () => Promise<
    BbntWishlistItemInput[]
  >;
}
const defaultValue = {} as unknown as PdpAddToWishlistConsumerInterface;
const PdpAddToWishlistContext = React.createContext(defaultValue);

export const PdpAddToWishlistProvider: React.FunctionComponent = (props) => {
  const readWishlistItemsToAddFromTheCurrentStateOfTheDocument =
    React.useCallback(async () => {
      const wishlistItems = await new Promise<BbntWishlistItemInput[]>(
        (resolve) => {
          (window.require as any)(["jquery"], function ($: any) {
            const $addToProductForm = $("#product_addtocart_form");

            const productSku = $addToProductForm.data("product-sku");

            const $productTable = $("#super-product-table");
            const $qtyInputs = $productTable.find("input.qty");

            let wishlistItems: BbntWishlistItemInput[] = [];
            $qtyInputs.each((index: number, qtyInput: any) => {
              const $qtyInput = $(qtyInput);
              const quantity = qtyInput.value;

              if (!quantity || quantity < 1) {
                return;
              }

              let thisProductParentSku: BbntWishlistItemInput["parent_sku"];
              let thisProductSku: BbntWishlistItemInput["sku"];
              let thisProductId: BbntWishlistItemInput["productId"];

              const childProductSku = $qtyInput.data("product-sku");
              const childProductId = $qtyInput.data("product-id");
              if (childProductSku) {
                thisProductParentSku = productSku;
                thisProductSku = childProductSku;
                thisProductId = childProductId;
              } else {
                thisProductSku = productSku;
              }

              let preexistingWishlistItem: BbntWishlistItemInput | undefined;
              if (!thisProductParentSku) {
                preexistingWishlistItem = wishlistItems.find(
                  ({ sku }) => sku === thisProductSku
                );
              }

              if (preexistingWishlistItem) {
                preexistingWishlistItem.quantity += quantity;
              } else {
                const newWishlistItemInput: BbntWishlistItemInput = {
                  parent_sku: thisProductParentSku,
                  sku: thisProductSku,
                  productId: thisProductId,
                  quantity: parseInt(quantity),
                };
                wishlistItems = [...wishlistItems, ...[newWishlistItemInput]];
              }
            });

            resolve(wishlistItems);
          });
        }
      );
      return wishlistItems;
    }, []);

  const value: PdpAddToWishlistConsumerInterface = React.useMemo(
    () => ({
      readWishlistItemsToAddFromTheCurrentStateOfTheDocument,
    }),
    [readWishlistItemsToAddFromTheCurrentStateOfTheDocument]
  );
  return (
    <PdpAddToWishlistContext.Provider value={value}>
      {props.children || []}
    </PdpAddToWishlistContext.Provider>
  );
};

export const usePdpAddToWishlist = () => {
  const context = React.useContext(PdpAddToWishlistContext);
  if (context === defaultValue) {
    throw new Error(
      "usePdpAddToWishlist must be used within a PdpAddToWishlistProvider"
    );
  }
  return context;
};
